import { CpuIcon } from 'lucide-react';

import { cn } from '@/lib/utils';
import { identityDot } from '../identityFill';
import type { ProfileIdentity } from '../modelsLedger';

const TILE = {
  sm: 'size-7 rounded-md text-xs',
  xs: 'size-5 rounded text-2xs',
} as const;

const GLYPH = { sm: 'size-4', xs: 'size-3' } as const;

const DOT = { sm: 'size-2.5', xs: 'size-2' } as const;

/**
 * A profile's marker on both AI usage tabs (spec 234 US1): the neutral tile every
 * Spend row wears, holding the model family's initial ("S" for Sonnet) or the chip
 * glyph for a model the catalog does not know, with the profile's identity dot on
 * its corner (research R2). An idle profile's dot is a ring, and Not recorded gets
 * the glyph and a grey ring (spec 252). Decorative: the name is always beside it.
 */
export function ProfileMark({
  identity,
  size = 'sm',
}: {
  identity: Pick<ProfileIdentity, 'slot' | 'letter'> & { idle?: boolean };
  /** `sm` beside a row's name, Spend's tile size; `xs` in a legend or a line. */
  size?: 'sm' | 'xs';
}) {
  const dot = identityDot(identity);
  return (
    <span
      aria-hidden="true"
      data-profile-mark=""
      className={cn(
        'bg-muted text-muted-foreground relative grid shrink-0 place-items-center font-semibold',
        TILE[size],
      )}
    >
      {identity.letter ?? (
        <CpuIcon className={GLYPH[size]} strokeWidth={1.75} />
      )}
      <span
        data-identity-dot=""
        className={cn(
          'ring-card absolute -end-0.5 -bottom-0.5 rounded-full ring-2',
          DOT[size],
          dot,
        )}
      />
    </span>
  );
}
